import { ApiClient } from './api/client.js';
import { CaptureFlow } from './flow/controller.js';
import { resultScreen, showScreen } from './ui/screens.js';

/**
 * Entry point — the KYC link carries the one-time claim token in the URL fragment
 * (#claim=…) so it never reaches server logs (§2/§3). On load the token is moved into
 * sessionStorage and stripped from the address bar/history; a reload resumes from
 * storage (re-claim is allowed for non-terminal sessions, §25).
 */
const STORAGE_KEY = 'kyc.claimToken';

function claimTokenFromUrl(): string | null {
  const match = /#claim=([^&]+)/.exec(window.location.hash);
  return match ? decodeURIComponent(match[1]!) : null;
}

function resolveClaimToken(): string | null {
  const fromUrl = claimTokenFromUrl();
  if (fromUrl) {
    try {
      sessionStorage.setItem(STORAGE_KEY, fromUrl);
    } catch {
      // Storage unavailable (private mode) — keep going with the in-memory token.
    }
    history.replaceState(null, '', window.location.pathname + window.location.search);
    return fromUrl;
  }
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

const root = document.getElementById('app')!;
const token = resolveClaimToken();

if (!token) {
  showScreen(root, resultScreen('error', 'This verification link is invalid or incomplete. Please request a new link.'));
} else {
  const flow = new CaptureFlow(root, new ApiClient());
  void flow.run(token);
}
